import { MESApiService, spParameter } from "@dexteel/mesf-core";

export const createPunchSpecs = async (
	punchSpecs: Record<string, unknown> & { ProductId: number },
) => {
	const apiService = new MESApiService();
	const val = (key: string) =>
		(punchSpecs[key] as string | number | null) ?? null;
	const parameters: spParameter[] = [
		{ name: "ProductId", value: punchSpecs.ProductId },
		{ name: "UpperRiserDrawingNum", value: val("UpperRiserDrawingNum") },
		{ name: "LowerRiserDrawingNum", value: val("LowerRiserDrawingNum") },
		{ name: "StopBlockNumber", value: val("StopBlockNumber") },
		{ name: "DrawingNumber", value: val("DrawingNumber") },
		{ name: "DrawingPath", value: val("DrawingPath") },
	];
	return await apiService.callV2("[FAB].[UpsertPunchSpecs]", parameters);
};

export const updatePunchSpecs = async (
	productId: number,
	fields: Record<string, string | number | boolean | null>,
) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [{ name: "ProductId", value: productId }];

	for (const [field, value] of Object.entries(fields)) {
		parameters.push({ name: field, value: value });
	}

	return await apiService.callV2("[FAB].[UpsertPunchSpecs]", parameters);
};

export const deletePunchSpecs = async (productId: number) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [{ name: "ProductId", value: productId }];
	return await apiService.callV2("[FAB].[DeletePunchSpecs]", parameters);
};
